import { FacetFilter } from '../models/facet-filter.model';
import { FacetValue, SearchRequestV2 } from '@usf/product-types';

export const isFieldNameSelected = (
  selectedFacetFilters: FacetFilter[],
  fieldName: string,
) => {
  return !!selectedFacetFilters?.find(
    selectedFacetFilter => selectedFacetFilter?.fieldName === fieldName,
  );
};

export const isFacetFilterSelected = (
  selectedFacetFilters: FacetFilter[],
  facetFilter: FacetFilter,
) => {
  return !!selectedFacetFilters?.find(
    selectedFacetFilter =>
      selectedFacetFilter?.fieldName === facetFilter?.fieldName &&
      selectedFacetFilter?.facetValue?.value === facetFilter?.facetValue?.value,
  );
};

export const buildFacetFilterArrayFromRequest = (
  request: SearchRequestV2,
): FacetFilter[] => {
  const selectedFacetFilters: FacetFilter[] = new Array<FacetFilter>();
  Object.keys(request?.facetFilters)?.forEach(fieldName => {
    request?.facetFilters[fieldName]?.forEach(faceValue => {
      selectedFacetFilters.push(buildFacetFilterObject(fieldName, faceValue));
    });
  });
  return selectedFacetFilters;
};

export const buildFacetFilterObject = (
  fieldName: string,
  faceValue: string,
): FacetFilter => {
  return {
    fieldName: fieldName,
    facetValue: {
      value: faceValue,
    } as FacetValue,
  } as FacetFilter;
};
